import React from 'react';
import { TypedMemo } from '../../common/types';
import { useMusic24Capabilities } from '../../music24/hooks/useMusic24Capabilities';
import { ConnectionsPanel } from './ConnectionsPanel';
import { CatalogConnections } from './useCatalogConnections';

interface CatalogConnectionsPanelProps {
  connections: CatalogConnections;
}

/** The connections panel of the Catalog screen, fed by `useCatalogConnections`. */
const CatalogConnectionsPanelComponent: React.FC<CatalogConnectionsPanelProps> = ({ connections: c }) => {
  const { canUseAutoUpload } = useMusic24Capabilities();
  return (
    <ConnectionsPanel
      connections={c.connections.connections}
      insights={c.insights}
      isLoading={c.connections.isLoading}
      error={c.connections.error}
      retry={c.connections.retry}
      onEditProfileUrl={c.onEditProfileUrl}
      onConnect={c.onConnect}
      onSync={c.onSyncConnection}
      onDisconnect={c.onDisconnectConnection}
      onChooseArtist={c.onChooseArtist}
      onShowMatrix={c.openMatrix}
      isBusy={c.portal.isBusy}
      portalError={c.portal.error}
      // The Spotify Canvas switch on the Spotify for Artists card (design spotify-canvas b5).
      showCanvasSwitch={canUseAutoUpload}
    />
  );
};

export const CatalogConnectionsPanel = TypedMemo(CatalogConnectionsPanelComponent);
